import React from "react";
import BaseModal from "views/uikit/VLModal/BaseModal";
import VLButton from "views/uikit/Buttons/VLButton";
import styles from "./style.module.scss";

interface ProductionConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ProductionConfirmationModal: React.FC<
  ProductionConfirmationModalProps
> = ({ isOpen, onClose, onConfirm, loading = false }) => {
  const footer = (
    <div className={styles.footer}>
      <VLButton
        type="default"
        text="Cancel"
        onClick={onClose}
        disabled={loading}
        className={styles.cancelButton}
      />
      <VLButton
        type="primary"
        text="Confirm"
        onClick={onConfirm}
        loading={loading}
        className={styles.confirmButton}
      />
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      variant="info"
      headers={{
        title: "Confirm removal from production",
        subTitle:
          "You are about to unmark this model as production. Are you sure?",
      }}
      footer={footer}
      size="default"
    />
  );
};

export default ProductionConfirmationModal;
